import { render, staticRenderFns } from "./LicencesWeb.vue?vue&type=template&id=10e330e8"
import script from "./LicencesWeb.vue?vue&type=script&lang=js"
export * from "./LicencesWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports